import React, {  useState, useEffect } from 'react';
import { Container, Form, Row, Col, Button } from '@themesberg/react-bootstrap';
import { get, post } from '../../../services/back.service';
import useAutosave from '../../../hooks/useAutosave';

// Varios formularios escriben sobre la cabecera del peritaje; cada uno declara
// su propio scope para que dos peritos puedan editarlos a la vez.
const SCOPE = 'header:obs';

function FormAdditionalObs({ id }) {
  const [msgButton, setMsgButton] =useState('Guardar Informacion')
  const [infoObsAdditional, setInfoObsAdditional] = useState({
    obs_additonal_1:'',
    obs_additonal_2:'',
    obs_additonal_3:'',
  });

  const autosave = useAutosave(async () => {
    await post('/peritaje/modifyinspection/header/'+id, { ...infoObsAdditional, scope: SCOPE });
  });

  const sendInfo = async (event) => {
    event.preventDefault();
    autosave.cancel();
    const body = { ...infoObsAdditional, scope: SCOPE };
    const respo = await post('/peritaje/modifyinspection/header/'+id, body);
    if(respo.success){
      setMsgButton('Actualizar')
    }
  };


  const handleForm = ({ target }) => {
    const value = target.type === 'checkbox' ? target.checked : target.value;
    setInfoObsAdditional({ ...infoObsAdditional, [target.name]: value });
    autosave.schedule();
    //generalUpdate(target.name, value);
  };

  useEffect(() => {
    const initForm = async () => {
      const respo = await get('/peritaje/infoinspection/'+id, {});
      if(respo.success){
        setInfoObsAdditional({
          obs_additonal_1: respo.data.obs_additonal_1,
          obs_additonal_2: respo.data.obs_additonal_2,
          obs_additonal_3: respo.data.obs_additonal_3,
        });
      }
    };
    initForm();
  }, [id]);

  return (
    <Container>
      <Row className="mb-1">
        <Col>
          <h1 className="fw-bold">OBSERVACIONES ADICIONALES</h1>
        </Col>
      </Row>
      <hr style={{ opacity: 0.1 }} />
      <Row>
        <Col>
          <Form.Label htmlFor="obs_additonal_1">Observacion 1 (Pagina 4)</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            name="obs_additonal_1"
            value={infoObsAdditional.obs_additonal_1}
            onChange={(e) => handleForm(e)}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Label htmlFor="obs_additonal_2">Observacion 2 (Pagina 4)</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            name="obs_additonal_2"
            value={infoObsAdditional.obs_additonal_2}
            onChange={(e) => handleForm(e)}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Label htmlFor="obs_additonal_3">Observacion 3 (Pagina 4)</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            name="obs_additonal_3"
            value={infoObsAdditional.obs_additonal_3}
            onChange={(e) => handleForm(e)}
          />
        </Col>
      </Row>
      <Row className="my-3">
        <Col className="d-flex justify-content-end">
          <Button type="button" variant="primary" onClick={sendInfo}>
          {msgButton}
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default FormAdditionalObs;
